



















import { Component, Mixins } from 'vue-property-decorator'
import { toArray, multiply } from 'lodash'

import { getPosition } from '@utils/index'
import { RECOVERYCATEGORY } from '../category.config'
import { LoadList } from '@shared/mixins/loadList'
import { queryCmmty } from '../category.service'
import { SuperMixin } from '../category.mixin'
import { AsyncStatus } from '@constant/index'
import { getSearchResult, RequestType, CategoryList } from '@pages/search/search-service'

import SelfOperatedComponent from '../components/selfOperatedGrayScale/selfOperated.vue'
import TabSelectComponent from '../components/tabSelectGrayScale/tabSelect.vue'
import RecoveryComponent from '../components/recovery/recovery.vue'
import TentantComponent from '../components/tentantGrayScale/tentant.vue'
import GoodsComponent from '../components/goods/goods.vue'

import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

@Component({
  components: {
    SelfOperatedComponent,
    TabSelectComponent,
    RecoveryComponent,
    TentantComponent,
    GoodsComponent,
    CategoryDefaultList: () => import('../components/categoryDefaultList/categoryDefaultList.vue'),
  },
})
export default class CommonComponent extends Mixins(LoadList, SuperMixin) {
  confition: any = null // 条件
  hasRecovery = false //产后恢复品类才有
  asyncYes: any = AsyncStatus.HAS
  asyncNo: any = AsyncStatus.NO
  hasConfition = AsyncStatus.unDef // 当前城市下有条件
  position: any = null
  isTentant = true //是商户
  selfOperatedData: any = null
  selectTag: any
  categoryList: CategoryList[] = []
  @categoryModule.Action getSelfOperatedDataGrayscale!: (payload: any) => Promise<any>

  get showAllEmpty() {
    return this.hasConfition === AsyncStatus.NO && (this.selfOperatedData ? this.selfOperatedData.worker && this.selfOperatedData.worker.length === 0 && this.selfOperatedData.spuList && this.selfOperatedData.spuList.length === 0 : true)
  }

  async created() {
    this.categoryList = [{ title: '全部', list: [{ title: '全部', categoryId: this.categoryIds?.join(',') }] }]
    this.hasRecovery = this.categoryId == RECOVERYCATEGORY
    this.getPosition()
  }
  async getPosition() {
    this.result.loading = true
    this.position = await getPosition()
    if (!this.hasRecovery) {
      const categoryId = this.categoryId && this.categoryId.length === 8 ? this.categoryId : this.categoryIds
      this.selfOperatedData = await this.getSelfOperatedDataGrayscale({
        positon: this.position,
        categoryId,
      })
    } else {
      this.selfOperatedData = {
        spuList: [],
        nearStore: null,
        worker: [],
      }
    }
    this.getList()
  }
  changeCondition(confition: any) {
    if (this.selectTag) {
      confition.level4CategoryIds = this.categoryIds
      const { isType1, itemType, isAll } = this.selectTag
      confition.itemType1 = isAll ? '' : isType1 ? itemType : ''
      confition.itemType2 = isAll ? '' : !isType1 ? itemType : ''
    }
    if (!this.confition) {
      this.confition = confition
    } else {
      this.setInitResult()
      this.confition = confition
      this.getList(confition.callback)
    }
  }
  changeRecoveryTag(value: any) {
    this.selectTag = value
    this.setInitResult()
    const { isType1, itemType, isAll } = this.selectTag
    this.confition.itemType1 = isAll ? '' : isType1 ? itemType : ''
    this.confition.itemType2 = isAll ? '' : !isType1 ? itemType : ''
    this.confition = { ...this.confition, level4CategoryIds: this.categoryIds }
    this.getList()
  }
  onLoad() {
    this.getList()
  }
  async getList(callback?: any) {
    let { categoryId, districtId, tabCut, saleNumSort = false, distanceSort = false, storeFavPersonNumSort = false } = this.confition
    let { itemType1, itemType2 } = this.confition
    let query = ''
    if (itemType1 || itemType2) {
      const data: any = {}
      itemType1 && (data.itemType1 = itemType1)
      itemType2 && (data.itemType2 = itemType2)
      query = JSON.stringify(data)
    }
    const pageIndex = ++this.result.pageIndex
    const pageSize = this.result.pageSize

    this.result.loading = true
    let response: ResponseCode
    const isTentantOld = this.isTentant
    if (tabCut == 1) {
      //商户
      //console.log(this.confition, this.position, '====>获取商户列表')
      this.isTentant = true
      if (pageIndex === 1 && this.hasConfition != AsyncStatus.HAS) {
        /* 这里的作用是：查一下看看有没有联营商户 */
        const responseTentant: ResponseCode = await getSearchResult({
          type: 2,
          tabs: '2',
          query,
          start: 0,
          limit: 1,
          openOption: this.categoryList.length === 1,
          position: this.position,
          level4CategoryId: categoryId,
          districtId,
          saleNumSort,
          distanceSort,
          storeFavPersonNumSort,
          isSelf: 2,
        })
        if (responseTentant && responseTentant.code == 1) {
          const businessInfo = responseTentant?.data?.businessInfo?.list
          this.hasConfition = businessInfo && businessInfo.length > 0 ? AsyncStatus.HAS : AsyncStatus.NO
        } else {
          this.hasConfition = AsyncStatus.NO
        }
      }
    } else if (tabCut == 2) {
      this.isTentant = false
    }
    if (this.hasConfition === AsyncStatus.NO) {
      return
    }
    if (isTentantOld != this.isTentant) {
      this.result.list = []
    }
    const TabType: RequestType = tabCut == 1 ? RequestType.RequestBuiness : tabCut == 2 ? RequestType.RequestProduct : RequestType.RequestAll
    response = await getSearchResult({
      type: TabType,
      tabs: `${TabType}`,
      query,
      start: multiply(pageIndex - 1, pageSize || 10),
      limit: pageSize,
      openOption: this.categoryList.length === 1,
      position: this.position,
      level4CategoryId: categoryId,
      districtId,
      saleNumSort,
      distanceSort,
      storeFavPersonNumSort,
      isSelf: 2,
    })
    if (pageIndex === 1) {
      this.result.list = []
    }
    this.result.loading = false
    if (response && response.code == 1) {
      const list: any[] = this.isTentant ? toArray(response.data.businessInfo.list) : toArray(response.data.cmmdtyInfo.list)
      this.result.list = this.result.list.concat(list)
      if (list.length < this.result.pageSize) {
        this.result.finished = true
      }
      if (response.data.categoryInfo && response.data.categoryInfo.length) {
        this.categoryList = this.getNewCategoryList(response.data.categoryInfo)
      }
    } else {
      --this.result.pageIndex
      this.result.error = true
    }
    callback && callback()
  }

  getNewCategoryList(payload: CategoryList[]) {
    payload.forEach((item: CategoryList) => {
      const num = item.list.length % 4
      const needAddTranslate = num > 1 ? 4 - num : 0 //>1的情况需要加几条空数据 方便ui  justify-content: space-between显示
      for (let index = 0; index < needAddTranslate; index++) {
        item.list.push({})
      }
    })
    return [{ title: '全部', list: [{ title: '全部', categoryId: this.categoryIds?.join(',') }] }, ...payload]
  }
}
